<div class="row list-item {{item.classes}}">
  <div class="col-auto align-middle" *ngIf="item.icon">
    <co-image [width]="'16'" [height]="'16'" [key]="item.icon" [imageSet]="item.imageSet"></co-image>
  </div>

  <div *ngIf="hasValue" class="col value text-break {{item.classes}}" [class.empty]="!hasValue" [innerHTML]="displayText | safeHtml"></div>
  <div *ngIf="!hasValue" class="col value text-break {{item.classes}}" [class.empty]="!hasValue" [innerHTML]="displayText | safeHtml" ></div>
  <!--<div class="col-auto" *ngIf="item.linkIcon">
  </div>-->
</div>